module.exports = __webpack_public_path__ + "static/media/about-certificate-img4.5665bf2f.jpg";